import { createClientCityRequest } from "../../data/clientCityApi";
import { validateClientCityPayload } from "../validator/validateClientCityPayload";

export async function createClientCityUseCase(payload) {
  const error = validateClientCityPayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await createClientCityRequest(payload);
}
